<div>
    <hub-modal-header
        headerText="{{ messagesOnly ? '#' + jobcard.jobCardID : jobcard.customer?.Name + ' ' + jobcard.customer?.Surname }}"
        headerSubText="{{ messagesOnly ? jobcard.customer?.Name + ' ' + jobcard.customer?.Surname : jobcard.selectedItem?.manufacturer + ' ' + jobcard.selectedItem?.model }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div class="messages-attachment-container" [class.messages-only]="messagesOnly">
        <div class="messages-container">
            <div id="messages-content" class="messages-content">

                <div *ngIf="!loadingMessages && notifications.length===0" class="no-messages">
                    {{'bikeshop.modal.update_job_card.messaging.no-notifications' | translate}}
                </div>

                <div *ngFor="let notification of notifications; let i = index; trackBy: trackByNotification">

                    <!-- Show date separator when date changes -->
                    <div *ngIf="shouldShowDateSeparator(notification, i)" class="date-separator">
                        <span class="date-text">{{ getDateDisplayText(notification.CreatedDate) }}</span>
                    </div>

                    <div class="message">
                        <div>
                            <div class="customer-header" *ngIf="notification.Direction==='Incoming'">
                                <div>{{jobcard.customer.Name}} {{jobcard.customer.Surname}}</div>
                                <div class="date">{{notification.CreatedDate | date : "h:mm a"}}</div>
                            </div>
                            <div class="store-header" *ngIf="notification.Direction==='Outgoing'">
                                <div class="date">{{notification.CreatedDate | date : "h:mm a"}}</div>
                                <div>{{notification.Type}}</div>
                            </div>
                            <div
                                [ngClass]="{'store': notification.Direction==='Outgoing', 'customer': notification.Direction==='Incoming'}">
                                <div [innerHTML]="notification.Message | linkify"></div>
                                <div class="footer">
                                    <div class="status">
                                        <div
                                            *ngIf="notification.DeliveryStatus == 'accepted' || notification.DeliveryStatus == 'sent'">
                                            <span class="fa fa-check"></span>
                                        </div>
                                        <div *ngIf="notification.DeliveryStatus == 'delivered'" class="double-check">
                                            <span class="fa fa-check"></span><span class="fa fa-check"></span>
                                        </div>
                                        <div *ngIf="notification.DeliveryStatus == 'read'" class="double-check read">
                                            <span class="fa fa-check"></span><span class="fa fa-check"></span>
                                        </div>
                                        <div *ngIf="notification.DeliveryStatus == 'failed'" class="failed"><span
                                                class="fa fa-exclamation-triangle"
                                                pTooltip="{{ notification.FailureReason }}"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="messages-footer">

                <div *ngIf="whatsappFeatureEnabled" class="whatsapp-info-container">
                    <div *ngIf="!hasInitiateChatTemplate && !isWhatsappCustomMessageWindowOpen">
                        <div class="whatsapp-title red">{{
                            'bikeshop.modal.update_job_card.messaging.no_whatsapp_initiate_chat_template' | translate }}
                        </div>
                    </div>

                    <div class="message-type-container">
                        <p-radioButton name="MessageType" value="WHATSAPP" label="Whatsapp"
                            [(ngModel)]="defaultMessageType"
                            [disabled]="!hasInitiateChatTemplate && !isWhatsappCustomMessageWindowOpen"></p-radioButton>
                        <p-radioButton name="MessageType" value="SMS" label="SMS" [(ngModel)]="defaultMessageType"
                            [disabled]="!hasInitiateChatTemplate && !isWhatsappCustomMessageWindowOpen"></p-radioButton>
                    </div>

                </div>
                <div class="messages-footer-send-container">
                    <hub-text-area [autofocus]="true" [(ngModel)]="messageText" [rows]="1" [autoGrow]="true" [rounded]="true"
                        (keydown.control.enter)="sendMessage()"
                        [disabled]="sendingMessage"></hub-text-area>
                    <hub-button [icon]="'send'" [style]="'primary'" [size]="'xl'" [loading]="sendingMessage" 
                        [disabled]="!messageText || sendingMessage" (buttonClick)="sendMessage()"></hub-button>
                </div>
                <div class="short-cut-container" *ngIf="messageText && messageText.length>0">
                    Ctrl <span><daz-icon [name]="'enter'" [size]="'18px'"
                    [color]="'#6B728C'"></daz-icon></span> <span>{{'bikeshop.workshop.jobcard.quote.to_send_the_message' |translate}}</span>
                </div>
            </div>
        </div>
        <div class="attachments-container" *ngIf="!messagesOnly" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
            (drop)="onFileDrop($event)" [class.drag-over]="isDragOver">
            <div class="attachments-content">
                <div *ngIf="!loadingAttachments && attachments.length === 0 && !isDragOver" class="no-attachments">
                    {{ 'bikeshop.workshop.jobcard.manage.attachments.no_attachments' | translate }}
                </div>
                <div class="attachments-container-inner" *ngIf="attachments.length > 0 && !isDragOver">
                    <div *ngFor="let item of attachments" class="attachment-item"
                        [class.uploading]="isUploadingItem(item)" [class.upload-error]="hasUploadError(item)">

                        <!-- Image Display -->
                        <div *ngIf="item?.mediaType?.indexOf('image') > -1">
                            <img [src]="item.mediaURL" [alt]="item.fileName" />

                            <!-- Upload Progress Overlay -->
                            <div *ngIf="isUploadingItem(item)" class="upload-overlay">
                                <div class="upload-progress-container">
                                    <div class="upload-progress-circle">
                                        <div class="progress-text">{{ item.uploadProgress | number:'1.0-0' }}%</div>
                                        <svg class="progress-ring" width="60" height="60">
                                            <circle class="progress-ring-background" cx="30" cy="30" r="25"></circle>
                                            <circle class="progress-ring-progress" cx="30" cy="30" r="25"
                                                [style.stroke-dasharray]="157.08"
                                                [style.stroke-dashoffset]="157.08 - (157.08 * item.uploadProgress / 100)">
                                            </circle>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <!-- Error Overlay -->
                            <div *ngIf="hasUploadError(item)" class="error-overlay">
                                <div class="error-actions">
                                    <button class="retry-btn" (click)="retryUpload(item); $event.stopPropagation()">
                                        <i class="fa fa-refresh"></i>
                                    </button>
                                    <button class="cancel-btn" (click)="cancelUpload(item); $event.stopPropagation()">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>

                            <span *ngIf="!isUploadingItem(item) && !hasUploadError(item)" class="expand-file">
                                <daz-icon [name]="'expand-wide'" [size]="'20px'" [color]="'#222222'"
                                    (click)="!isUploadingItem(item) && openAttachment(item)"></daz-icon>
                            </span>
                            <!-- Delete Button (only for uploaded items) -->
                            <span *ngIf="!isUploadingItem(item) && !hasUploadError(item)" class="delete-file">
                                <daz-icon [name]="'trash'" [size]="'20px'" [color]="'#222222'"
                                    (click)="deleteAttachment(item, $event)"></daz-icon>
                            </span>
                        </div>

                        <!-- File Attachment Display -->
                        <div *ngIf="item?.mediaType?.indexOf('image') === -1" class="file-attachment"
                            (click)="!isUploadingItem(item) && openAttachment(item)">

                            <!-- Upload Progress for Files -->
                            <div *ngIf="isUploadingItem(item)" class="file-upload-progress">
                                <i class="fa fa-file"></i>
                                <div class="progress-bar">
                                    <div class="progress-fill" [style.width.%]="item.uploadProgress"></div>
                                </div>
                                <span class="progress-text">{{ item.uploadProgress | number:'1.0-0' }}%</span>
                            </div>

                            <!-- Normal File Display -->
                            <div>
                                <i class="fa fa-file"></i>
                            </div>
                            <span *ngIf="!isUploadingItem(item) && !hasUploadError(item)" class="expand-file">
                                <daz-icon [name]="'expand-wide'" [size]="'20px'" [color]="'#222222'"
                                    (click)="!isUploadingItem(item) && openAttachment(item)"></daz-icon>
                            </span>

                            <!-- Delete Button (only for uploaded items) -->
                            <span *ngIf="!isUploadingItem(item) && !hasUploadError(item)" class="delete-file">
                                <daz-icon [name]="'trash'" [size]="'20px'" [color]="'#222222'"
                                    (click)="deleteAttachment(item, $event)"></daz-icon>
                            </span>


                            <!-- Error State for Files -->
                            <div *ngIf="hasUploadError(item)" class="file-error-state">
                                <i class="fa fa-exclamation-triangle"></i>
                                <button class="retry-btn" (click)="retryUpload(item)">Retry</button>
                                <button class="cancel-btn" (click)="cancelUpload(item)">Cancel</button>
                            </div>
                        </div>

                        <!-- Filename with Upload Status -->
                        <div class="filename">
                            <p-inplace #fileName *ngIf="!isUploadingItem(item) && !hasUploadError(item)">
                                <span pInplaceDisplay class="filename-text">
                                    {{ item.fileName }}
                                </span>
                                <span pInplaceContent>
                                    <div class="p-inputgroup">
                                        <input pInputText type="text" [(ngModel)]="item.fileName"
                                            (keyup.enter)="updateFileName(fileName, item)"
                                            (blur)="updateFileName(fileName, item)" />
                                        <span class="p-inputgroup-addon" (click)="updateFileName(fileName, item)">
                                            <i class="fa fa-check"
                                                [ngClass]="{ 'red': item.fileName && item.fileName.length > 0 }"></i>
                                        </span>
                                    </div>
                                </span>
                            </p-inplace>

                            <!-- Upload Status Text -->
                            <div *ngIf="isUploadingItem(item)" class="upload-status">
                                <span class="filename-text">{{ item.fileName }}</span>
                                <span class="status-text">Uploading...</span>
                            </div>

                            <!-- Error Status Text -->
                            <div *ngIf="hasUploadError(item)" class="error-status">
                                <span class="filename-text">{{ item.fileName }}</span>
                                <span class="status-text error">Upload failed</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Drag and Drop Overlay -->
                <div *ngIf="isDragOver" class="drag-drop-overlay">
                    <div class="drag-drop-content">
                        <i class="fa fa-cloud-upload fa-3x"></i>
                        <h4>{{ 'bikeshop.workshop.jobcard.manage.attachments.drop_files_here' | translate }}</h4>
                        <p>{{ 'bikeshop.workshop.jobcard.manage.attachments.release_to_upload' | translate }}</p>
                    </div>
                </div>

            </div>
            <div class="attachments-footer">
                <div>
                    <div>
                        <hub-button [icon]="'plus-alt'" [style]="'outline'" [size]="'xl'"
                            (click)="fileUpload.click()"></hub-button>
                        <input #fileUpload type="file" multiple accept="image/*;capture=camera" style="display: none"
                            (change)="addAttachment($event)">
                    </div>
                    <div>
                        {{ 'bikeshop.workshop.jobcard.manage.attachments.add_attachment' | translate }}
                    </div>
                </div>
                <div>
                    <div>
                        <div class="qr-container" *ngIf="url && url.length>0">
                            <qrcode [qrdata]="url" [width]="100" colorDark="#1e1e1e" [elementType]="'svg'" [errorCorrectionLevel]="'L'"></qrcode>
                        </div>
                    </div>
                    <div>
                        {{ 'bikeshop.workshop.jobcard.manage.attachments.scan_qr_code' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p-toast position="bottom-center" styleClass="hubtiger-jobcard-toast" key="messages-attachments"></p-toast>